import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import utils from './utils/utils'
import appUtils from './utils/appUtils'
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
import './assets/css/style.css'
import './assets/css/common.css'

Vue.config.productionTip = false
Vue.prototype.$utils = utils
Vue.prototype.$appUtils = appUtils
Vue.prototype.$layer = layer(Vue)

// import Vconsole from 'vconsole'
// let vConsole = new Vconsole()
// Vue.use(vConsole)

Raven.config('https://b52394bc0d284b128f0e58b34c7bdd5d@error.jiankanghao.net/55').addPlugin(RavenVue, Vue).install();

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
